/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Bridge settings
 * @export
 * @interface InternalApiBridgeSettings
 */
export interface InternalApiBridgeSettings {
    /**
     * 
     * @type {string}
     * @memberof InternalApiBridgeSettings
     */
    tokenUrl: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBridgeSettings
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBridgeSettings
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBridgeSettings
     */
    webhookSecret?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBridgeSettings
     */
    organisationEmail?: string;
}

/**
 * Check if a given object implements the InternalApiBridgeSettings interface.
 */
export function instanceOfInternalApiBridgeSettings(value: object): value is InternalApiBridgeSettings {
    if (!('tokenUrl' in value) || value['tokenUrl'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientSecret' in value) || value['clientSecret'] === undefined) return false;
    return true;
}

export function InternalApiBridgeSettingsFromJSON(json: any): InternalApiBridgeSettings {
    return InternalApiBridgeSettingsFromJSONTyped(json, false);
}

export function InternalApiBridgeSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBridgeSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'tokenUrl': json['tokenUrl'],
        'clientId': json['clientId'],
        'clientSecret': json['clientSecret'],
        'webhookSecret': json['webhookSecret'] == null ? undefined : json['webhookSecret'],
        'organisationEmail': json['organisationEmail'] == null ? undefined : json['organisationEmail'],
    };
}

export function InternalApiBridgeSettingsToJSON(json: any): InternalApiBridgeSettings {
    return InternalApiBridgeSettingsToJSONTyped(json, false);
}

export function InternalApiBridgeSettingsToJSONTyped(value?: InternalApiBridgeSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tokenUrl': value['tokenUrl'],
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'webhookSecret': value['webhookSecret'],
        'organisationEmail': value['organisationEmail'],
    };
}

